import 'babel-polyfill';

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 */

// window.__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
// window.__Zone_disable_on_property = true; // disable patch onProperty such as onclick
// window.__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames

/*
* in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
* with the following flag, it will bypass `zone.js` patch for IE/Edge
*/
window.__Zone_enable_cross_context_check = true;

import 'zone.js/dist/zone';
import 'whatwg-fetch';

import URLSearchParams from 'url-search-params';

try {
  if (new window.URLSearchParams('q=%2B').get('q') !== '+') {
    throw new Error('URLSearchParams not correctly implemented');
  }
} catch (error) {
  window.URLSearchParams = URLSearchParams;
}
